function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);} /* eslint-disable max-lines */
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';


import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions, Control, Field } from 'react-redux-form';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { FormGroup } from "../../Forms";
import ColorPicker from "../../Forms/components/ColorPicker";
import { I18NLink, t, Translate } from "../../I18N";
import { notificationActions } from "../../Notifications";
import { notify } from "../../Notifications/actions/notificationsActions";
import {
  addProperty,
  inserted,
  saveTemplate,
  countByTemplate } from "../actions/templateActions";

import MetadataProperty from "./MetadataProperty";
import RemovePropertyConfirm from "./RemovePropertyConfirm";
import { AddThesaurusButton } from "../../Thesauri/components/AddThesaurusButton";
import { AddRelationshipTypeButton } from "../../RelationTypes/components/AddRelationshipTypeButton";
import { COLORS } from "../../utils/colors";



import { Form } from "../../Forms/Form";
import { TemplateAsPageControl } from "./TemplateAsPageControl";
import { validate } from "./ValidateTemplate";



















const getTemplateDefaultColor = (allTemplates, template) =>
template.data.color ? template.data.color : COLORS[allTemplates.size % COLORS.length];

class MetadataTemplate extends Component {

































  constructor(props) {
    super(props);_defineProperty(this, "confirmation", { templateConflict: { title: 'Template conflict', key: 'Mapping conflict error', text: `A reindex of your collection is necessary. The reason may vary
       -- from certain changes made to a template's property to new fields
       that need to be populated across entities.
       This process will not negatively affect the data in your collection.
       It can last a few minutes and some parts of your collection might take
       some time to reappear in the Library, but this is temporary. Do you want to continue?` }, largeNumberOfEntities: { title: 'Lengthy reindex process', key: 'Template with a long number of entities', text: `The template has changed and the associated entities will be re-indexed,
      this process may take several minutes, do you want to continue?` } });_defineProperty(this, "onSubmit", async (_template) => {var _template$properties;const template = _objectSpread({}, _template);
      if (this.props.environment === 'relationType') {
        template.commonProperties = undefined;
      }
      template.properties = (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.map((_prop) => {
        const prop = _objectSpread({}, _prop);
        prop.label = _prop.label.trim();
        return prop;
      });
      if (template._id) {
        const entitiesCountOfTemplate = await countByTemplate(template);
        const lengthyReindexFloorCount = 30000;
        if (entitiesCountOfTemplate >= lengthyReindexFloorCount) {
          return this.confirmAndSaveTemplate(template, 'largeNumberOfEntities');
        }
      }
      try {
        await this.props.saveTemplate(template);
      } catch (e) {
        if (e.status === 409) return this.confirmAndSaveTemplate(template, 'templateConflict');
      }
    });this.onSubmit = this.onSubmit.bind(this);this.onSubmitFailed = this.onSubmitFailed.bind(this);}

  onSubmitFailed() {
    this.props.notify(t('System', 'The template contains errors', null, false), 'danger');
  }

  confirmAndSaveTemplate(
  template,
  confirmationKey)
  {
    return this.props.mainContext.confirm({
      accept: () => {
        try {
          this.props.saveTemplate(_objectSpread(_objectSpread({}, template), {}, { reindex: confirmationKey === 'templateConflict' }));
        } catch (e) {
          if (e.status === 409) return this.confirmAndSaveTemplate(template, 'templateConflict');
        }
      },

      cancel: () => {},
      title: this.confirmation[confirmationKey].title,
      messageKey: this.confirmation[confirmationKey].key,
      message: this.confirmation[confirmationKey].text,
      type: 'success',
      acceptLabel: 'Confirm',
      zIndex: 99
    });
  }

  render() {
    const { connectDropTarget, defaultColor, environment, syncedTemplate } = this.props;
    const commonProperties = this.props.commonProperties || [];
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(RemovePropertyConfirm, {}), /*#__PURE__*/
      _jsx(Form, {
        model: "template.data",
        onSubmit: this.onSubmit,
        onSubmitFailed: this.onSubmitFailed,
        className: "metadataTemplate",
        validators: validate(
          this.props.properties,
          commonProperties,
          this.props.templates.toJS(),
          this.props._id
        ) }, void 0,

      environment === 'template' && syncedTemplate && /*#__PURE__*/
      _jsx("div", { className: "metadataTemplate-sync" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), " \xA0", /*#__PURE__*/
      _jsx(Translate, { translationKey: "syncedTemplateEditorMessage" }, void 0, "This template is synced from another instance. Only entity view page can be enabled."

      )
      ), /*#__PURE__*/


      _jsx("div", { className: "metadataTemplate-heading" }, void 0, /*#__PURE__*/
      _jsx(FormGroup, { model: ".name" }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".name" }, void 0, /*#__PURE__*/
      _jsx("input", {
        placeholder: t('System', 'Template name', null, false),
        className: "form-control",
        disabled: syncedTemplate }
      )
      )
      ),
      defaultColor && !(environment === 'relationType') && /*#__PURE__*/
      _jsx(Control, {
        model: ".color",
        component: ColorPicker,
        defaultValue: defaultColor,
        mapProps: {
          defaultValue: (props) => props.defaultValue
        },
        disabled: syncedTemplate }
      )

      ),

      environment === 'template' && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "metadataTemplate-pageview" }, void 0, /*#__PURE__*/
      _jsx(FormGroup, { model: ".entityViewPage" }, void 0, /*#__PURE__*/
      _jsx(TemplateAsPageControl, { selectedPage: this.props.entityViewPage || '' })
      )
      ),
      connectDropTarget( /*#__PURE__*/
        _jsx("ul", { className: "metadataTemplate-list list-group" }, void 0,
        commonProperties.map((property, index) => /*#__PURE__*/
        React.createElement(MetadataProperty, _extends({},
        property, {
          key: property.localID,
          localID: property.localID,
          index: index - commonProperties.length,
          syncedTemplate: syncedTemplate })
        )
        ),
        this.props.properties.map((property, index) => /*#__PURE__*/
        _jsx(MetadataProperty, {
          _id: property._id,
          type: property.type,
          inserting: property.inserting,

          localID: property.localID,
          index: index,
          syncedTemplate: syncedTemplate
          // relationships v2
          , query: property.query,
          denormalizedProperty: property.denormalizedProperty }, property.localID
        )
        ),
        !syncedTemplate && /*#__PURE__*/
        _jsx("div", { className: "no-properties" }, void 0, /*#__PURE__*/
        _jsx("span", { className: "no-properties-wrap" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "clone" }), /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Drag properties here")
        )
        )

        )
      )
      ), /*#__PURE__*/


      _jsx("div", { className: "settings-footer remove-extra-nesting" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: this.props.backUrl, className: "btn btn-default btn-plain" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-left", directionAware: true }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Back")
      )
      )
      ),
      environment === 'template' && /*#__PURE__*/
      _jsx("div", { className: "btn-cluster lg-margin-left-12 sm-order-1 sm-footer-extra-row" }, void 0, /*#__PURE__*/
      _jsx(AddThesaurusButton, {}), /*#__PURE__*/
      _jsx(AddRelationshipTypeButton, {})
      ), /*#__PURE__*/

      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: this.props.backUrl, className: "btn btn-default btn-extra-padding" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Cancel")
      )
      ), /*#__PURE__*/
      _jsx("button", {
        type: "submit",
        className: "btn btn-success save-template btn-extra-padding",
        disabled: !!this.props.savingTemplate }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      )
      )
      ));

  }
}

/* eslint-disable react/forbid-prop-types, react/require-default-props */_defineProperty(MetadataTemplate, "defaultProps", { notify, /* eslint-disable react/default-props-match-prop-types */saveTemplate, environment: 'template', /* eslint-enable react/default-props-match-prop-types */savingTemplate: false, defaultColor: null, properties: [], mainContext: { confirm: (_props) => {} } });
















/* eslint-enable react/forbid-prop-types, react/require-default-props */

const target = {
  canDrop() {
    return true;
  },

  drop(props, monitor) {
    const item = monitor.getItem();

    const propertyAlreadyAdded = props.properties[item.index];

    if (propertyAlreadyAdded) {
      props.inserted(item.index);
      return {};
    }

    props.addProperty({ label: item.label, type: item.type }, props.properties.length);
    return { name: 'container' };
  }
};

const dropTarget = DropTarget('METADATA_OPTION', target, (connector) => ({
  connectDropTarget: connector.dropTarget()
}))(MetadataTemplate);

const mapStateToProps = (
{
  template,
  templates,
  relationTypes













},

props) =>
{
  const environment = props.relationType ? 'relationType' : 'template';
  const _templates = environment === 'relationType' ? relationTypes : templates;
  return {
    _id: template.data._id,
    commonProperties: template.data.commonProperties,
    properties: template.data.properties,
    entityViewPage: template.data.entityViewPage,
    syncedTemplate: template.data.synced,
    templates: _templates,
    savingTemplate: template.uiState.get('savingTemplate'),
    defaultColor: getTemplateDefaultColor(templates, template),
    environment
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { inserted, addProperty, setErrors: formActions.setErrors, notify: notificationActions.notify },
    dispatch
  );
}

export { dropTarget, MetadataTemplate, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  withContext(dropTarget)
);